












import Modal from "../core/Modals/Modal";
import InterventionControlEdit from "./InterventionControlModalPartials/InterventionControlEdit";

export default {
    name: "InterventionControlModal",
    components: { InterventionControlEdit, Modal },
    props: {
        interventions: Array,
        showModal: Boolean,
    },
    methods: {
        closeModal(): void {
            this.$emit("close-modal");
        },
    },
};
